import { useState } from 'react';
import { showDialogConfermaModifica } from '../../../../../utils/dialog/showDialogFunction';
import { DatiMercato, ElementUpdateIndicePenConValue, IndicePenetrazioneCash, QuotaBanca, SourceRead } from '../../../../../api/apiTypes';
import { updateIndiceDiPentrazione } from '../../../../../api/functionApi';
import Swal from 'sweetalert2';
import { formatSnakeToTitle } from '../../../../../utils/Format';
import SourcesAccordion from '../../../../../components/report/SourcesAccordion';
import { useAxiosInterceptor } from '../../../../../api/wrappers';
import ElementGenerationsPanel from '../../../ElementGenerationsPanel';
import EventList from '../../../../../utils/EventList';

interface DataFromParent {
  mercato: DatiMercato;
  title: string;
  driverRoute: string;
  elements: IndicePenetrazioneCash[];
  id: string;
  driverId: string;
  sources: SourceRead[];
  indiceID: string;
  validated: boolean;
  events: any[];
}

const ContainerIndiceDiPenetrazionePageDettaglio = ({ mercato, elements, indiceID, id, driverId, sources, validated, events }: DataFromParent) => {
  useAxiosInterceptor();
  const [isEditing, setIsEditing] = useState(false);
  const [values, setValues] = useState<Record<string, number>>(() =>
    Object.fromEntries(mercato.banks.map(bank => [bank.name, bank.share]))
  );

  const nome = mercato.market_name;

  const handleModifica = () => {
    showDialogConfermaModifica(() => {
      setIsEditing(true);
    });
  };

  const handleAnnulla = () => {
    setValues(Object.fromEntries(mercato.banks.map(bank => [bank.name, bank.share])));
    setIsEditing(false);
  };

  const handleSalva = async () => {
    try {
      for (const element of elements) {
        const updatedRawData = element.raw_data.map(market => {
          if (market.market_name === mercato.market_name) {
            return {
              ...market,
              banks: market.banks.map(bank => ({
                ...bank,
                share: values[bank.name] ?? bank.share,
              })),
              market_traded_value: values['valoreScambiato'] ?? market.market_traded_value,
            };
          }
          return market;
        });

        const payload: ElementUpdateIndicePenConValue = {
          value: {
            raw_data: updatedRawData,
          },
        };

        await updateIndiceDiPentrazione(id, driverId, indiceID, payload);
      }

      Swal.fire({
        icon: 'success',
        title: 'Modifica salvata!',
        text: 'Le modifiche sono state salvate correttamente.',
        confirmButtonColor: '#374151',
      });

      setIsEditing(false);
          validated = false;

    } catch (error) {
      console.error('Errore durante il salvataggio:', error);
      Swal.fire({
        icon: 'error',
        title: 'Errore nel salvataggio',
        text: 'Si è verificato un errore durante il salvataggio delle modifiche.',
        confirmButtonColor: '#374151',
      });
    }
  };


  const handleInputChange = (bankName: string, newValue: string) => {
    const parsedValue = parseFloat(newValue);
    if (!isNaN(parsedValue)) {
      setValues(prev => ({ ...prev, [bankName]: parsedValue }));
    } else if (newValue === '') {
      setValues(prev => ({ ...prev, [bankName]: 0 }));
    }
  };

  // Raggruppa ogni 4 banche
  const groupedBanks: QuotaBanca[][] = [];
  for (let i = 0; i < mercato.banks.length; i += 4) {
    groupedBanks.push(mercato.banks.slice(i, i + 4));
  }

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-8">
      <h2 className="text-3xl font-bold text-[#1B365D] mb-8">
        {formatSnakeToTitle(nome)}
      </h2>

      {groupedBanks.map((group, index) => (
        <div
          key={index}
          className="grid grid-cols-1 md:grid-cols-4 gap-x-8 gap-y-6 mb-6"
        >
          {group.map(bank => {
            return (
              <div key={bank.name}>
                <label
                  htmlFor={bank.name}
                  className={`block text-sm font-medium mb-1 px-2 py-1 rounded ${bank.selected ? 'bg-gray-700 text-white' : 'text-gray-600'
                    }`}
                >
                  {bank.name === bank.detected_name
                    ? bank.name
                    : `${bank.name} (${bank.detected_name})`}
                </label>

                <input
                  type="number"
                  id={bank.name}
                  value={values[bank.name]}
                  readOnly={!isEditing}
                  onChange={e => handleInputChange(bank.name, e.target.value)}
                  className={`mt-1 block w-full rounded-md border border-gray-300 focus:border-[#1B365D] focus:ring focus:ring-[#1B365D]/20 p-2 ${isEditing ? 'bg-white' : 'bg-gray-100'
                    }`}
                />
              </div>
            );
          })}
        </div>
      ))}

{/* Campo "Valore Scambiato" */}
<div className="mb-6">
  <label
    htmlFor="valoreScambiato"
    className="block text-sm font-medium text-gray-600 mb-1"
  >
    Valore Scambiato
  </label>
  <input
    type="number"
    id="valoreScambiato"
    value={values['valoreScambiato'] ?? mercato.market_traded_value}
    readOnly={!isEditing}
    onChange={e =>
      handleInputChange('valoreScambiato', e.target.value)
    }
    className={`mt-1 block w-[23%] rounded-md border border-gray-300 focus:border-[#1B365D] focus:ring focus:ring-[#1B365D]/20 p-2 mr-4 ${
      isEditing ? 'bg-white' : 'bg-gray-100'
    }`}
  />
</div>

{!['approved', 'drafted', 'completed'].includes(elements[0]?.report_status ?? '') && (

      <div className="flex justify-end space-x-4 mt-8">
        {!isEditing ? (
          <>
            
              <button
                onClick={handleModifica}
                className="px-4 py-2 bg-[#1B365D] text-white hover:bg-[#142a4a] rounded-lg"
              >
                Modifica
              </button>
            
          </>
        ) : (
          <>
            <button
              onClick={handleAnnulla}
              className="px-4 py-2 bg-gray-200 text-gray-800 hover:bg-gray-300 rounded"
            >
              Annulla
            </button>
            <button
              onClick={handleSalva}
              className="px-4 py-2 bg-[#1B365D] text-white hover:bg-[#142a4a] rounded-lg"
            >
              Salva
            </button>
          </>
        )}
      </div>
      )}
      <SourcesAccordion sources={sources} reportId={id} componentId={driverId} elementId={indiceID} />

                 {/* Sezione Attività */}
<EventList events={events} />
      <ElementGenerationsPanel reportId={id} componentId={driverId} elementId={indiceID} />
    </div>
  );
};

export default ContainerIndiceDiPenetrazionePageDettaglio;
